export const itemsPerPage = 10

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// export const filterPart = [
//   { label: 'Select Employee' },
//   { label: 'Date From' },
//   { label: 'Date To' },
//   { label: 'Select Status' },
//   { text: 'Search' },
//   { text: 'Add Employee', className: classes.button2, handleSubmit: handleOpen },
// ]
